import { render } from "./RegistrationByEmailPage.vue?vue&type=template&id=52718bae&scoped=true"
import script from "./RegistrationByEmailPage.vue?vue&type=script&lang=js"
export * from "./RegistrationByEmailPage.vue?vue&type=script&lang=js"

import "./RegistrationByEmailPage.vue?vue&type=style&index=0&id=52718bae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52718bae"]])

export default __exports__